import { IThemeComponentVariation, IThemeVariationProperties, ThemeKey } from '@belong/types';
import { COLOURS, SHADOWS } from '../helpers';
import { componentVariations as getComponentsDark } from './dark';
import { componentVariations as getComponentsLight } from './light';

export const DARK_NEUTRAL_BACKGROUND_VARIATIONS: Pick<IThemeComponentVariation, 'icon'> = {
  icon: { spotBackgroundColor: 'BLACK' }
};

export const getThemeVariations = (): Record<ThemeKey, IThemeVariationProperties> => ({
  // define variations here
  Light: {
    backgroundColor: COLOURS.WHITE,
    backgroundColorDark: COLOURS.GREY_200,
    backgroundColorLight: COLOURS.GREY_100,
    foregroundColor: COLOURS.GREY_600,
    foregroundColorDark: COLOURS.BLACK,
    foregroundColorLight: COLOURS.GREY_500,
    borderColor: COLOURS.GREY_300,
    borderColorDark: COLOURS.GREY_500,
    borderColorLight: COLOURS.GREY_200,
    outlineColor: COLOURS.BELONG_BLUE_ALT,
    focusRingColor: COLOURS.BELONG_BLUE_ALT,
    shadows: SHADOWS,
    baseFontColor: COLOURS.BLACK,
    greyFontColor: COLOURS.GREY_500,
    ...getComponentsLight()
  },
  Dark: {
    backgroundColor: COLOURS.BLACK,
    backgroundColorDark: COLOURS.GREY_700,
    backgroundColorLight: COLOURS.GREY_600,
    foregroundColor: COLOURS.GREY_100,
    foregroundColorDark: COLOURS.GREY_100,
    foregroundColorLight: COLOURS.GREY_100,
    borderColor: COLOURS.GREY_600,
    borderColorDark: COLOURS.GREY_400,
    borderColorLight: COLOURS.BELONG_BLUE_LIGHT,
    outlineColor: COLOURS.BELONG_BLUE_ALT,
    focusRingColor: COLOURS.BELONG_BLUE_ALT,
    baseFontColor: COLOURS.WHITE,
    greyFontColor: COLOURS.GREY_400,
    ...getComponentsDark()
  }
});
